import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelect, MatOption } from '@angular/material/select';

export type AddFilterControlType = 'multiselect' | 'hierarchal' | 'hierarchal-delimiter' | 'date';

export interface AddFilterDraft {
  label: string;
  name: string;
  column: string;
  type: AddFilterControlType;
  default_selection: string;
}

const EMPTY_DRAFT: AddFilterDraft = {
  label: '',
  name: '',
  column: '',
  type: 'multiselect',
  default_selection: 'All'
};

/**
 * "Visual Editor" tab of the Add filter popup - manual form to define a new filter.
 * Starts empty; can also be pre-filled from the ASK tab's generated draft.
 */
@Component({
    selector: 'app-add-filter',
    templateUrl: './add-filter.component.html',
    styleUrl: './add-filter.component.scss',
    imports: [FormsModule, MatSelect, MatOption]
})
export class AddFilterComponent implements OnChanges {
  @Input() draft: AddFilterDraft | null = null;
  @Output() draftChange = new EventEmitter<AddFilterDraft>();

  readonly controlTypeOptions: Array<{ value: AddFilterControlType; label: string }> = [
    { value: 'multiselect', label: 'Multi-select dropdown' },
    { value: 'hierarchal', label: 'Hierarchy' },
    { value: 'hierarchal-delimiter', label: 'Hierarchy (delimited)' },
    { value: 'date', label: 'Date' }
  ];

  readonly defaultSelectionOptions = ['All', 'None'];

  form: AddFilterDraft = { ...EMPTY_DRAFT };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['draft']) {
      this.form = this.draft ? { ...this.draft } : { ...EMPTY_DRAFT };
    }
  }

  get isValid(): boolean {
    return !!this.form.label.trim() && !!this.form.name.trim() && !!this.form.column.trim() && !!this.form.type;
  }

  onFieldChange(): void {
    this.draftChange.emit({ ...this.form });
  }
}
